import Icon from '../components/Icon.vue'

Icon.register({"user-check":{"width":640,"height":512,"paths":[{"d":"M224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM313.6 288H296.9C274.7 298.2 250 304 224 304S173.4 298.2 151.1 288H134.4C60.2 288 0 348.2 0 422.4V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V422.4C448 348.2 387.8 288 313.6 288zM636.6 159.6L608.8 131.5C604.2 126.8 596.7 126.8 592 131.4L487.2 235.4 441.7 189.6C437.1 184.9 429.6 184.9 424.9 189.5L396.8 217.4C392.1 222 392.1 229.5 396.7 234.2L478.4 316.5C483 321.2 490.5 321.2 495.2 316.6L636.5 176.4C641.1 171.7 641.2 164.2 636.6 159.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-check.js
// module id = VpUt
// module chunks = 0